import { forwardRef, useEffect, useState, useContext } from "react";
import { ConfigContext } from "../util/ConfigContext";
import detectedPlatform from "../util/PlatformUtils";

import {
  XMarkIcon,
  NewspaperIcon,
  ChatBubbleLeftRightIcon,
  ArrowDownTrayIcon,
  KeyIcon,
} from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";

export function RedirectLoginPath() {
  const host = window.location.hostname;
  if (
    host === "localhost" ||
    host === "multiapp.ac" ||
    host === "www.multiapp.ac"
  ) {
    return "/universal/login";
  } else {
    return "/";
  }
}

const Sidebar = forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { jwt } = useContext(ConfigContext);

  useEffect(() => {
    if (ref?.current) {
      ref.current.openHomeSidebar = () => setIsOpen(true);
    }
  }, [ref]);

  const closeSidebar = () => setIsOpen(false);

  // Close on escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") closeSidebar();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  // Prevent scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [isOpen]);

  // const menuItems = [
  //   ...(jwt
  //     ? [{ name: "Schedule", icon: VideoCameraIcon, path: "/schedule" }]
  //     : [
  //         {
  //           name: "Login",
  //           icon: KeyIcon,
  //           path: RedirectLoginPath(),
  //         },
  //       ]),
  //   { name: "Downloads", icon: ArrowDownTrayIcon, path: "/downloads" },
  //   { name: "Privacy Policy", icon: NewspaperIcon, path: "/privacy-policy" },
  //   { name: "Auth Redirect", icon: LinkIcon, path: "/auth/redirect" },
  // ];

  const menuItems = [
    ...(jwt
      ? [
          // Show "Schedule" only if role is NOT SUBSCRIBER or HOST
          // ...(jwt.role !== "SUBSCRIBER" && jwt.role !== "HOST"
          //   ? [{ name: "Schedule", icon: VideoCameraIcon, path: "/schedule" }]
          //   : []),

          { name: "Downloads", icon: ArrowDownTrayIcon, path: "/downloads" },
        ]
      : [
          {
            name: "Login",
            icon: KeyIcon,
            path: RedirectLoginPath(),
          },
        ]),
    { name: "Privacy Policy", icon: NewspaperIcon, path: "/privacy-policy" },
    { name: "Contact Us", icon: ChatBubbleLeftRightIcon, path: "/contact" },
  ];

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/30"
          onClick={closeSidebar}
        />
      )}

      <div
        className={`fixed top-0 left-0 z-50 h-full w-64 bg-white dark:bg-gray-900 shadow-lg transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
            Menu
          </h2>
          <button onClick={closeSidebar}>
            <XMarkIcon className="w-6 h-6 text-gray-600 dark:text-gray-300" />
          </button>
        </div>

        <nav className="p-4 space-y-2">
          {menuItems.map(({ name, icon: Icon, path }) => {
            if (name === "Downloads" && detectedPlatform() !== "web") {
              return null; // Hide Downloads if not web
            }

            return (
              <Link
                key={name}
                to={path}
                onClick={closeSidebar}
                className={`flex items-center gap-3 p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition ${
                  location.pathname === path
                    ? "bg-gray-200 dark:bg-gray-700 font-semibold"
                    : ""
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{name}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
});

export default Sidebar;
